var PubSub = require("underpub-js");

var HeaderNavigation = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

HeaderNavigation.prototype.init = function(){

  var self = this;

  /*

  this.prevScrollPosition = 0;

  // on scroll
  PubSub.subscribe("scroll", function(){
    self.updateNavScroll();
  });

  // make sure that if we're at the top of the page, the navigation is being shown
  // only do this if there isn't a full width nav at the top
  if (!this.options.$el.hasClass('hide-at-top'))
  {
    window.setInterval(function() {
      if (window.pageYOffset < 320) {
        self.showNav();
      }
    }, 1000);
  }

  */

  // mobile nav trigger
  this.options.$el.find('.mobile-nav-trigger').on('click', function() {

  	if ($(this).hasClass('is-active'))
  	{
  		PubSub.publish("hideMobileNavOverlay", {});
  	}
  	else
  	{
  		PubSub.publish("showMobileNavOverlay", {});
  	}

  	$(this).toggleClass('is-active');

  });

  PubSub.subscribe("deactivateHamburgers", function(){
    self.deactivateHamburger();
  });

  PubSub.subscribe("activateHamburgers", function(){
    self.activateHamburger();
  });

  /*
  PubSub.subscribe("disableHeaderNavigation", function(){
    self.disableNav();
  });

  PubSub.subscribe("enableHeaderNavigation", function(){
    self.enableNav();
  });
  */

};

/*
HeaderNavigation.prototype.updateNavScroll = function(){

  var self = this;

  var currentScrollPos = window.pageYOffset;

  if ((currentScrollPos < 320) && (!this.options.$el.hasClass('hide-at-top'))) {
    // near top - show navigation
    self.showNav();
  }
  else{

    if (this.prevScrollPosition > currentScrollPos) {
      // scrolled up, check if nav should be shown

      window.setTimeout(function() {

        self.checkShowNav(currentScrollPos);

      }, 200);
    }
    else {
      // scrolled down, hide
      self.hideNav();
    }
  }

  this.prevScrollPosition = currentScrollPos;

};
*/

/*
 *  This function checks to see if the user is scrolling up fast enough to turn on the nav.
 *  It is called 2/10 of a second after the scroll is initiated, and checks to see if the user scrolled
 *  more than 75 pixels in that amount of time. If they have, then the nav is shown.
 */
 /*
HeaderNavigation.prototype.checkShowNav = function(prevScrollPos){

  var self = this;

  var currentScrollPos = window.pageYOffset;

  if (currentScrollPos < (prevScrollPos - 75))
  {
    if (!self.options.$el.hasClass('hidden-at-top'))
    {
      self.showNav();
    }
  }

};
*/

/*
HeaderNavigation.prototype.showNav = function(){
  this.options.$el.removeClass('hidden').addClass('shown');
};

HeaderNavigation.prototype.hideNav = function(){
  this.options.$el.removeClass('shown').addClass('hidden');
};

HeaderNavigation.prototype.enableNav = function(){
  this.options.$el.removeClass('hidden-at-top');
};

HeaderNavigation.prototype.disableNav = function(){
  this.options.$el.addClass('hidden-at-top');

  if (!this.options.$el.hasClass('hidden'))
  {
    this.options.$el.addClass('hidden');
  }
};
*/

HeaderNavigation.prototype.activateHamburger = function(){
  this.options.$el.find('.mobile-nav-trigger').addClass('is-active');
};

HeaderNavigation.prototype.deactivateHamburger = function(){
  this.options.$el.find('.mobile-nav-trigger').removeClass('is-active');
};

module.exports = HeaderNavigation;
